import { WebLink, YammerState } from '../../state/types';
import { createFindById, createFindByIdThrows } from '../findById';

export const findById = createFindById<WebLink>('webLinks');
export const findByIdThrows = createFindByIdThrows<WebLink>('webLinks');

type GetFulfilledWebLinks = (state: YammerState) => Record<string, WebLink>;
export const getFulfilledWebLinks: GetFulfilledWebLinks = (state) => state.webLinks.fulfilled.byId;
